import React from 'react';
import Button from 'grommet/components/Button';
import OptimizeIcon from 'grommet/components/icons/base/Optimize';
import Box from 'grommet/components/Box';
import Tiles from 'grommet/components/Tiles';
import Tile from 'grommet/components/Tile';
import Anchor from 'grommet/components/Anchor';
import NumberInput from 'grommet/components/NumberInput';
import Label from 'grommet/components/Label';

class Anomaly extends React.Component {
    constructor() {
        super();
        this.state = { 
            steps: 4,
            epsilon: 0.01
             }
        this._onSelect = this._onSelect.bind(this);
    }
    _onClick(output) {
        //this.props.onSubmit()
        this.props.onSubmit(output)
    }
    _onSelect(event) {
        this.setState({steps: event})
    }
    _onChange(field, event) {
        switch(field) {
            case "steps":
                this.setState({ steps: event.target.value})
                break;
            case "epsilon":
                this.setState({ epsilon: event.target.value})
                break;
        }
    }
    render() {
        const {steps, epsilon} = this.state
        const output = {steps, epsilon}
        let content = (
                <div>
                <Box direction='row'
                        justify='center'
                        align='center'
                        wrap={true}
                        reverse={false}
                        margin='none'>
                        <Box direction='row'
                            align='center'
                            wrap={true}
                            pad='small'
                            margin='none'>
                            
                            <Label>
                            {"Steps"}
                            </Label>
                            <Box direction='row'
                            align='center'
                            wrap={true}
                            pad='small'
                            margin='none'>
                                <NumberInput defaultValue={4} step={1} onChange={this._onChange.bind(this, 'steps')} />
                            </Box>
                        </Box>
                        <Box direction='row'
                            align='center'
                            wrap={true}
                            pad='small'
                            margin='none'>
                            <Label>
                            {"Epsilon"}
                            </Label>
                            <Box direction='row'
                            align='center'
                            wrap={true}
                            pad='small'
                            margin='none'>
                                <NumberInput defaultValue={0.01} step={0.01} onChange={this._onChange.bind(this, 'epsilon')} />
                            </Box>
                        </Box>
                </Box>
                <Button label='Submit'
            type='submit'
            primary={true}
            onClick={this._onClick.bind(this, output)} />
                </div>
            )
        return (
            <div>
                <h2><strong>Chose Options</strong></h2>
                <div style={{paddingTop: "10px"}}>
                {content}
                </div>
            </div>  
        );
    }
}

export default Anomaly;




// WEBPACK FOOTER //
// ./src/samples/options/anomaly.js